// @flow
export const CHANGE_ALL_PRODUCT_STATES = 'hive/thermostat/CHANGE_ALL_PRODUCT_STATES';
export const CHANGE_PRODUCT_STATE = 'hive/thermostat/CHANGE_PRODUCT_STATE';
export const SET_HUMIDIFIER_TYPE = 'hive/thermostat/SET_HUMIDIFIER_TYPE';
export const CHANGED_PRODUCT_STATE = 'hive/thermostat/CHANGED_PRODUCT_STATE';
export const CACHE_PRODUCT_TEMPERATURE = 'hive/thermostat/CACHE_PRODUCT_TEMPERATURE';



// WEBPACK FOOTER //
// ./src/core/state/products/thermostat/constants.js